import { Suspense } from "react";
import { QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

import { APP_BASENAME } from "app-constants";
import { CheckServiceAvailability, FormProvider, Loader } from "components";
import { AuthProvider, CheckTransitionsProvider } from "contexts";
import { useLanguageHeader } from "hooks";

import { AppRouter } from "./AppRouter";
import { queryClient } from "./query-client";

function App() {
  useLanguageHeader();

  return (
    <BrowserRouter basename={APP_BASENAME}>
      <QueryClientProvider client={queryClient}>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <Suspense fallback={<Loader size="lg" spread />}>
            <FormProvider>
              <AuthProvider>
                <CheckServiceAvailability>
                  <CheckTransitionsProvider>
                    <AppRouter />
                  </CheckTransitionsProvider>
                </CheckServiceAvailability>
              </AuthProvider>
            </FormProvider>
          </Suspense>
        </QueryParamProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
